<template>
    <div class="container">
        <div class="row">
            <div class="col-xl-3 col-12 mb-3">
                <div class="card">
                    <div class="card-header blue-gradient">Crear categorías agenda</div>
                    <div class="card-body">
                        <div class="form-group">
                            <label for="name">Nombre</label>
                            <input type="text" class="form-control" placeholder="Nombre de la categoría" v-model="category.name">
                        </div>

                        <input class="btn btn-primary" type="button" value="Guardar" @click.prevent="storeScheduleCategory">
                    </div>
                </div>
            </div>
            <div class="col-xl-9 col-12">
                <div class="card">
                    <div class="card-header green-gradient">Categorías creadas</div>
                    <div class="card-body">
                        <table class="table table-stripped text-center" id="categories-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nombre</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(currentCategory, i) in categories" :key="currentCategory.id">
                                    <td>{{currentCategory.id}}</td>
                                    <td>{{currentCategory.name}}</td>
                                    <td width="50px">
                                        <input type="button" value="✕" class="btn btn-danger btn-sm" @click="deleteCategory(currentCategory, i)">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'cities',
    mounted: function(){
        this.fetchCategories();
    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_API,
            cities: [],
            categories: [],
            category: {
                name: '',
            },
            table: null
        }
    },
    methods: {
        fetchCategories: function(){
            let _this = this;
            let loader = this.$loading.show();
            this.$http.get(
                `${this.baseUrl}/admin/schedules-categories`, 
                {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                _this.categories = data.body.data;
                var categoriesTable = $("#categories-table");
                window.setTimeout(()=>{this.renderTable(categoriesTable)}, 0);
                loader.hide();
            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        },
        storeScheduleCategory: function(){
            if(this.category.name != ""){
                let loader = this.$loading.show();
                this.$http.post(
                    `${this.baseUrl}/admin/schedules-categories`, this.category,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
                .then(data => {
                    console.log(data);
                    this.fetchCategories();
                    loader.hide();
                    this.category.name = "";
                    
                    window.location.reload();
                })
                .catch(error => {
                    loader.hide();
                });
            } else {
                this.$dialogs.alert("Se requiere un nombre", {title: 'Error', size: 'sm'});
            }
        },
        deleteCategory(category, i){
            let _this = this;
            this.$dialogs.confirm(`¿Desea borrar la categoría con nombre ${category.name}?`, {title: "Eliminar", size: "sm", okLabel: "Sí", cancelLabel: "Cancelar"})
            .then(response => {
                if(response.ok){
                    const loader = this.$loading.show();
                    const requestUrl = `${this.baseUrl}/admin/schedules-categories/${category.id}`;
                    this.$http.delete(requestUrl,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
                    .then(data => {
                        this.$dialogs.alert("Categoría borrada con éxito", {title: "Éxito", size: "sm"});
                        _this.categories.splice(i, 1);
                        loader.hide();
                    })
                    .catch(error => {
                        if(error.status == 409){
                            loader.hide();
                        }
                    });
                }
            });
        },
        renderTable(table){
            if(this.table != null){
                this.table.destroy();
            }

            this.table = table.DataTable({
                destroy: true,
                "language": {
                    "sProcessing":     "Procesando...",
                    "sLengthMenu":     "Mostrar _MENU_ registros",
                    "sZeroRecords":    "No se encontraron resultados",
                    "sEmptyTable":     "Ningún dato disponible en esta tabla",
                    "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix":    "",
                    "sSearch":         "Buscar:",
                    "sUrl":            "",
                    "sInfoThousands":  ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst":    "Primero",
                        "sLast":     "Último",
                        "sNext":     "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    }
                }
            });
        }
    }

}
</script>
<style lang="sass" scoped>
    @import '../../assets/scss/colors';
</style>


